// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__UT5cj","titulo":"Loading_titulo__JFPUa","gif":"Loading_gif__BhI4C"};